import { css } from '@emotion/css'
import { spacing, fontFamily, fontSize, fontWeight, colors } from '@offerzen/pinata-shame'

const styles = {
  button: css({
    background: 'none',
    backgroundColor: colors.white,
    border: 'none',
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.normal,
    fontSize: fontSize.default,
    padding: spacing.default,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    width: '100%',
    cursor: 'pointer',
    margin: 0,
    transition: 'color 0.2s, background-color 0.2s',

    '&:hover, &:focus': {
      backgroundColor: colors.hawkesBlue,
      color: colors.cornflowerBlue,
      outline: 'none',
    },

    '&:disabled': {
      color: colors.oxfordBlue,
      fontWeight: fontWeight.semiBold,
      pointerEvents: 'none',
      cursor: 'default',
    },
  }),
}

export default styles
